module.exports = __webpack_public_path__ + "img/join_btn.c67b1e98.gif";